import { useState, useEffect, useCallback } from 'react';

const useCloseBanner = (storageKeys) => {
  const [hiddenItems, setHiddenItems] = useState(null);

  const removeBanner = useCallback((e) => {
    const key = e.currentTarget.name;
    localStorage.setItem(key, 'true');
    setHiddenItems((value) => ({ ...value, [key]: true }));
  }, []);

  useEffect(() => {
    const entries = storageKeys.map((key) => [key, localStorage.getItem(key)]);
    setHiddenItems(Object.fromEntries(entries));
  }, [storageKeys]);

  return [hiddenItems, removeBanner];
};

export default useCloseBanner;
